module.exports = __webpack_public_path__ + "img/wechat.b2989705.jpg";